import Storage from './Storage';

const Api = {

  async get(url, params) {
    return xhr('GET', url, null, params);
  },

  put(url, body, params) {
    return xhr('PUT', url, body, params)
  },

  post(url, body, params) {
    return xhr('POST', url, body, params)
  },

  delete(url, params) {
    return xhr('DELETE', url, null, params)
  },

  setHeader(name, value) {
    headers[name] = value;
  },

  removeHeader(name) {
    delete headers[name];
  },
};

export default Api;

////////////

const GENERIC_ERROR_CODE = 'error.generic';

const token = Storage.getSessionItem('token') || Storage.getItem('token');
const connectedToken = Storage.getSessionItem('connected-token');
const lg = Storage.getItem('lg');

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'dataType': 'json',
};
if (token) {
  Api.setHeader('Authorization', token);
}
if (connectedToken) {
  Api.setHeader('x-connected-token', connectedToken);
}
if (lg) {
  Api.setHeader('Accept-Language', lg);
}

const handleStatus = (response) => {
  if (response.ok) {
    // The response was OK, but it cannot be parsed as JSON (eg: receiving xml or plain text)
    return response;
    // response.json()
    //   .catch(err => {
    //     console.log('Response cannot be parsed as json : ' + err);
    //     throw err;
    //   });
  }
  throw response;
};

const parseBody = (response) => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.startsWith('application/json')){
    return response.text().then((text) => {
      return text ? {body:JSON.parse(text), headers: response.headers} : {body:{}, headers: response.headers};
    })
  } else {
    return response.blob();
  }
};

const buildUrl = (url, params) => {
  let baseUrl = '/api' + url;

  if (params && Object.keys(params).length > 0) {
    const query = Object.keys(params)
      .map(k => {
        if (Array.isArray(params[k])) {
          if (k === 'sort') {
            return encodeURIComponent(k) + '=' + params[k].map(v => encodeURIComponent(v)).join(',')
          } else {
            return params[k].map(v=> encodeURIComponent(k) + '=' + encodeURIComponent(v)).join('&');
          }

        }
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
      })
      .join('&');
    baseUrl += '?' + query;
  }
  return baseUrl;
};

const handleError = (response) => {
  const status = (response && response.status) || 500;

  let error = new Error(status.toString());
  error.status = status;

  if (!response.json) {
    error.code = GENERIC_ERROR_CODE;

    return error;
  }

  return parseBody(response)
    .then((response) => {
      if (response.body && response.body.content) {
        error.content = response.body.content;
        return error;
      }
      error.code = response.body.code || GENERIC_ERROR_CODE;
      return error;
    })
    .catch(() => {
      error.code = GENERIC_ERROR_CODE;
      return error;
    });
};

const xhr = async (method, baseUrl, body, params) => {

  const url = buildUrl(baseUrl, params);

  const options = {
    headers: {...headers},
    method: method
  };

  if (body) {
    if (body instanceof FormData){
      options.body =body;
      delete options.headers['Content-Type'];
      delete options.headers['Accept'];
      delete options.headers['dataType'];
    } else {
      options.body = JSON.stringify(body);
    }
  }

  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then(handleStatus)
      .then(parseBody)
      .then(response => {
        resolve(response);
      })
      .catch(handleError)
      .then(error => {
        reject(error);
      });
  });

};



// WEBPACK FOOTER //
// ./src/services/Api.js